export default __webpack_public_path__ + "static/media/ellipse.c0282832.png";